import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Home/Home";
import Landing from "./Components/Landing/Landing";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import Service from "./Components/Service/Service";
import Career from "./Components/Career/Career";
import Repay from "./Components/Repay/Repay";
import InvestorRelations from "./Components/InvestorRelations/InvestorRelations";
import Leadership from "./Components/Leadership/Leadership";
import OurProducts from "./Components/OurProducts/OurProducts";
import BoardOfDirectors from "./Components/Leadership/BoardOfDirectors";
import LeadershipTeam from "./Components/Leadership/LeadershipTeam";
import BoardCommittees from "./Components/Leadership/BoardCommittees";
import Blogs from "./Components/Blogs/Blogs";
import BlogArticle from "./Components/Blogs/BlogArticle";
import Partners from "./Components/Partners/Partners";
import TermsConditions from "./Components/Legal/TermsConditions";
import PrivacyPolicy from "./Components/Legal/PrivacyPolicy";
import FairPracticeCode from "./Components/Legal/FairPracticeCode";
import GrievanceRedressalPolicy from "./Components/Legal/GrievanceRedressalPolicy";
import InterestRatePolicy from "./Components/Legal/InterestRatePolicy";
import CorporateGovernance from "./Components/Legal/CorporateGovernance";
import RecoveryPolicy from "./Components/Legal/RecoveryPolicy";
import LoanCalculator from "./Components/Landing/LoanCalculator";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main className="pt-20">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Home />} />
        <Route path="/our-products" element={<OurProducts />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<Service />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogArticle />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/career" element={<Career />} />
        <Route path="/repay" element={<Repay />} />
        <Route path="/investor-relations" element={<InvestorRelations />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/leadership/board-of-directors" element={<BoardOfDirectors />} />
        <Route path="/leadership/leadership-team" element={<LeadershipTeam />} />
        <Route path="/leadership/board-committees" element={<BoardCommittees />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/fair-practice-code" element={<FairPracticeCode />} />
        <Route path="/grievance-redressal-policy" element={<GrievanceRedressalPolicy />} />
        <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
        <Route path="/corporate-governance" element={<CorporateGovernance />} />
        <Route path="/recovery-policy" element={<RecoveryPolicy />} />
        <Route path="/loan-calculator" element={<LoanCalculator />} />
      </Routes>
      <Footer />
      </main>
    </Router>
  );
}

export default App;
